import { useDialog } from '@dni-hooks/useDialog'
import { Dialog } from '@fortune-ui'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useTranslation } from 'react-i18next'
import { SERVER_ERROR_DIALOG_KEY } from '../constants/dialogKey'

interface DialogReviseDateComponentProps {
  onClose: () => void
}

const DialogServerErrorComponent = ({ onClose }: DialogReviseDateComponentProps) => {
  const { t } = useTranslation()
  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="center" height="70px" mb={4}>
        <Text align="center" variant="h4" color={colors.grey900}>{t('wpOrder.serverErrorDialogContent')}</Text>
      </Box>
      <Button fullWidth onClick={onClose}>
        {t('wpMyAccount.confirm')}
      </Button>
    </>
  )
}

export function DialogServerError() {
  const { open, closeDialog } = useDialog(SERVER_ERROR_DIALOG_KEY)

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={closeDialog}
      disablePortal
      sx={{
        '& .MuiPaper-root': {
          p: '16px',
          maxWidth: '320px',
          borderRadius: '8px',
        },
      }}
    >
      <DialogServerErrorComponent
        onClose={closeDialog}
      />
    </Dialog>
  )
}
